
import { useDispatch, useSelector } from "react-redux";
import {
	saveSelectedUsersForSharing,
} from "../actions/form";
import React, { useState } from "react";
import { ESRState } from "../types/data";
import { UserTableData } from "./UsersManagement";
import {
	Box,
	Button,
	Modal,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useLocalStorage } from "react-use";
import { User } from "../auth";
import {useParams} from "react-router-dom";

// Define types for props
interface AutocompleteModalProps {
	esrId: string;
	isOpen: boolean;
	onClose: () => void;
}

export const UserSharingSelection: React.FC<AutocompleteModalProps> = ({
	esrId: string,
	isOpen,
	onClose,
}) => {
	const dispatch = useDispatch();

	const { esrId = "", activeId } = useParams();

	const [selectedusers, setSelectedUsers] = useState<any[]>([]);
	const [user, setUser] = useLocalStorage<User | null>("user");
	const user_list: UserTableData[] = useSelector((state: ESRState) => {
		return Object.keys(state.user_list).map((email: string) => {
			const user = state.user_list[email];
			return {
				created: user.created,
				email: email,
				name: user.first_name + " " + user.last_name,
				enabled: user.enabled,
				groups: user.groups,
				access_level: user.admin ? "Admin" : "User",
				actions: true,
			};
		});
	});

	// useEffect(() => {
	// 	if (user !== undefined && user !== null) {
	// 		// console.log("user shareing")
	// 		// dispatch(listAllUsers());
	// 	}
	// }, [user]);

	// Handle Save button click and dispatch selected items to Redux store
	const handleSave = () => {
		if (activeId) {
			dispatch(saveSelectedUsersForSharing(activeId, selectedusers.map(user => user.id)));
		}
		onClose();
	};

	return (
		<Modal open={isOpen} onClose={onClose}>
			<Paper
				elevation={6}
				sx={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					background: "white",
					transition: "all 200ms ease-in-out",
					padding: "2em",
					width: "40em",
				}}
			>
				<Box>
					<Autocomplete
						multiple
						options={user_list.map(user => ({
							label: `${user.name} <${user.email}>`,
							id: user.email
						}))}
						onChange={(event, newValue) => {
							setSelectedUsers(newValue)}
						}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="standard"
								label="Select Users to Share"
							/>
						)}
					/>
				</Box>
				<Button onClick={handleSave}>Save</Button>
				<Button onClick={onClose}>Cancel</Button>
			</Paper>
		</Modal>
	);
};
